import FormButton from './button';
import FormInput from './input';
import FormRadio from './radio';

export const Button = FormButton;
export const Input = FormInput;
export const Radio = FormRadio;
